import * as Sentry from "@sentry/browser";

/**
 * @param {String} message
 */
export function trackMessage(message) {
  Sentry.captureMessage(message);
}

/**
 * @param {Error} error
 */
export function trackException(error) {
  Sentry.captureException(error);
}

/**
 * @param {Error} error
 * @param {Object} errorInfo
 */
export function trackReactComponentError(error, errorInfo) {
  Sentry.withScope((scope) => {
    Object.keys(errorInfo).forEach((key) => {
      scope.setExtra(key, errorInfo[key]);
    });
    trackException(error);
  });
}
